import { createFileRoute } from "@tanstack/react-router";
import { ogImageMeta } from "@/lib/seo/og-image";
import { MlpPlatformPageBg } from "@/components/site/MlpPlatformPageBg";
import { MLP_PLATFORM_META_DESCRIPTION_BG } from "@/content/meta/MlpPlatformPageBg";

import { pageSchemas } from "@/lib/seo/page-schema";
export const Route = createFileRoute("/bg/media-monitoring/platform")({
  head: () => ({
    meta: [
      { title: "Платформа за медиен мониторинг | Perceptica" },
      { name: "description", content: MLP_PLATFORM_META_DESCRIPTION_BG },

      { property: "og:title", content: "Платформа за медиен мониторинг | Perceptica" },
      { property: "og:description", content: MLP_PLATFORM_META_DESCRIPTION_BG },
      { name: "twitter:card", content: "summary_large_image" },
      { name: "twitter:title", content: "Платформа за медиен мониторинг | Perceptica" },
      { name: "twitter:description", content: MLP_PLATFORM_META_DESCRIPTION_BG },
      { property: "og:url", content: "https://perceptica.com/bg/media-monitoring/platform" },
      ...ogImageMeta("bg", "/media-monitoring/platform"),
      { property: "og:type", content: "website" },
    ],
  
    scripts: pageSchemas({ locale: "bg", path: "/media-monitoring/platform", service: { name: "Платформа за медиен мониторинг", description: "Платформа за медиен мониторинг и медийно разузнаване от Perceptica.", serviceType: "Платформа за медиен мониторинг" }, software: true }),
  }),
  component: MlpPlatformPageBg,
});
